import { render, staticRenderFns } from "./FieldForm.vue?vue&type=template&id=5af090cd&scoped=true"
import script from "./FieldForm.vue?vue&type=script&lang=js"
export * from "./FieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af090cd",
  null
  
)

export default component.exports